<script lang="js">
import Swal from "sweetalert2";
import { mapGetters } from 'vuex';

export default {
  name: 'StaffNavbar',
  data() {
    return {
      isDevelopment: process.env.NODE_ENV === "development",
    }
  },
  computed: {
    ...mapGetters(['getStaff']),
    allMenuItems() {
      // Use different routes for development vs production
      if (this.isDevelopment) {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/staff", module: "dashboard" },
          { name: "Database", label: "Database", icon: "bi bi-database", route: "/staff/database", module: "database" },
          { name: "Academics", label: "Academics", icon: "bi bi-building-fill", route: "/staff/academics", module: "academics" },
          { name: "Exams", label: "Exams", icon: "bi bi-book", route: "/staff/exams", module: "exams" },
          { name: "Applications", label: "Applications", icon: "bi bi-file-earmark-text", route: "/staff/applications", module: "applications" },
          { name: "Admission Partners", label: "Admission Partners", icon: "bi bi-person-lines-fill", route: "/staff/admission-partners", module: "admissionPartners" },
          { name: "Students", label: "Students", icon: "bi bi-people", route: "/staff/students", module: "students" },
          { name: "Staffs", label: "Staffs", icon: "bi bi-person-badge", route: "/staff/staff", module: "staff" },
          { name: "Payments", label: "Payments", icon: "bi bi-cash-coin", route: "/staff/payments", module: "payments" },
          { name: "Utilities", label: "Utilities", icon: "bi bi-tools", route: "/staff/utilities", module: "utilities" },
          { name: "Reports", label: "Reports", icon: "bi bi-graph-up", route: "/staff/reports", module: "reports" },
          { name: "Scholarship", label: "Scholarship", icon: "bi bi-mortarboard", route: "/staff/scholarship", module: "scholarship" },
          { name: "Careers", label: "Careers", icon: "bi bi-folder-fill", route: "/staff/careers", module: "careers" },
          { name: "Notifications", label: "Notifications", icon: "bi bi-bell", route: "/staff/notifications", module: "notifications" },
          { name: "Settings", label: "Settings", icon: "bi  bi-gear", route: "/staff/settings", module: "settings" }
        ];
      } else {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/dashboard", module: "dashboard" },
          { name: "Database", label: "Database", icon: "bi bi-database", route: "/database", module: "database" },
          { name: "Academics", label: "Academics", icon: "bi bi-building-fill", route: "/academics", module: "academics" },
          { name: "Exams", label: "Exams", icon: "bi bi-book", route: "/exams", module: "exams" },
          { name: "Reports", label: "Reports", icon: "bi bi-graph-up", route: "/reports", module: "reports" },
          { name: "Applications", label: "Applications", icon: "bi bi-file-earmark-text", route: "/applications", module: "applications" },
          { name: "Admission Partners", label: "Admission Partners", icon: "bi bi-person-lines-fill", route: "/admission-partners", module: "admissionPartners" },
          { name: "Students", label: "Students", icon: "bi bi-people", route: "/students", module: "students" },
          { name: "Staffs", label: "Staffs", icon: "bi bi-person-badge", route: "/staff", module: "staff" },
          { name: "Payments", label: "Payments", icon: "bi bi-cash-coin", route: "/payments", module: "payments" },
          { name: "Utilities", label: "Utilities", icon: "bi bi-tools", route: "/utilities", module: "utilities" },
          { name: "Scholarship", label: "Scholarship", icon: "bi bi-mortarboard", route: "/scholarship", module: "scholarship" },
          { name: "Careers", label: "Careers", icon: "bi bi-folder-fill", route: "/careers", module: "careers" },
          { name: "Notifications", label: "Notifications", icon: "bi bi-bell", route: "/notifications", module: "notifications" },
          { name: "Settings", label: "Settings", icon: "bi  bi-gear", route: "/settings", module: "settings" }
        ];
      }
    },
    menuItems() {
      // Always show Dashboard, Reports and Settings regardless of permissions
      const dashboardItem = this.allMenuItems.find(item => item.name === "Dashboard");
      const reportsItem = this.allMenuItems.find(item => item.name === "Reports");
      const settingsItem = this.allMenuItems.find(item => item.name === "Settings");

      // If no staff data, only show Dashboard, Reports and Settings
      if (!this.getStaff) {
        return [dashboardItem, reportsItem, settingsItem].filter(Boolean);
      }

      // Filter menu items using the hasModule permission getter
      return this.allMenuItems.filter(item => {
        if (item.name === "Dashboard" || item.name === "Reports" || item.name === "Settings") return true;
        return this.$store.getters.hasModule(item.module);
      });
    },
    dashboardRoute() {
      // Return environment-appropriate dashboard route
      return this.isDevelopment ? '/staff' : '/dashboard';
    }
  },
  methods: {
    async logout() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will be logged out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Logout",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$store.dispatch('staffLogout');
          Swal.fire("Logged Out!", "You have been successfully logged out.", "success");
          this.$router.push({ name: 'staffLogin' });
        }
      });
    },
    closeNavbar() {
      // Close the main navbar collapse on mobile
      const navbarCollapse = document.getElementById('navbarSupportedContent');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const bsCollapse = this.$bootstrap.Collapse.getInstance(navbarCollapse);
        if (bsCollapse) {
          bsCollapse.hide();
        }
      }
    },
    handleNavigation() {
      // Close navbar when navigation occurs
      this.closeNavbar();
    }
  },
  mounted() { },
  components: {},
  created: function () { }
}
</script>

<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top"
    style="background-color: #181c1f !important"
  >
    <div class="container-fluid">
      <RouterLink
        class="navbar-brand d-flex align-items-center gap-2"
        :to="dashboardRoute"
      >
        <img
          src="@/assets/logo.png"
          alt="Logo"
          width="56.26"
          height="40"
          class="d-inline-block align-middle"
        />
        <h6 class="fw-bold text-uppercase m-0">Staff</h6>
      </RouterLink>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-flex d-lg-none">
          <li
            v-for="item in menuItems"
            :key="item.name"
            class="nav-item"
            :class="{ active: $route.path === item.route }"
          >
            <RouterLink
              class="nav-link d-flex align-items-center"
              :to="item.route"
              @click="handleNavigation"
            >
              <i :class="item.icon + ' fs-4'"></i>
              <span class="small ms-2">{{ item.label }}</span>
            </RouterLink>
          </li>
        </ul>
        <form class="me-5 d-flex flex-grow-1" role="search">
          <input
            class="form-control me-2 w-100 bg-light border-dark text-white"
            type="search"
            placeholder="Search"
            aria-label="Search"
          />
        </form>

        <div class="mb-lg-0">
          <a class="btn btn-link text-danger ms-3" @click="logout">
            <i class="bi bi-box-arrow-right fs-5"></i>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<style scoped></style>
